import React from 'react';

function AdoptionSteps() {
  const steps = [
    { icon: '🐾', title: '1. Scegli il cane', desc: 'Guarda le nostre schede e innamorati.' },
    { icon: '📝', title: '2. Invia richiesta', desc: 'Compila il questionario pre-affido online.' },
    { icon: '🤝', title: '3. Colloquio conoscitivo', desc: 'Incontriamoci al canile per parlare un po\'.' },
    { icon: '🏡', title: '4. Visita pre-affido', desc: 'Veniamo a conoscere il futuro ambiente del cane.' },
    { icon: '❤️', title: '5. Adozione finale', desc: 'Firma i documenti e porta a casa il tuo nuovo amico!' },
  ];

  return (
    <section className="section container" id="come-adottare">
      <h2 className="section-title">Come adottare</h2>
      <p className="section-subtitle">Il nostro processo di adozione è pensato per garantire il benessere del cane e la felicità della tua famiglia.</p>
      
      <div className="steps-container animate-on-scroll">
        {steps.map((step, index) => (
          <div className="step-item" key={index}>
            <div className="step-icon">{step.icon}</div>
            <h4 className="step-title">{step.title}</h4>
            <p className="step-desc">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AdoptionSteps;
